export default "__VITE_ASSET__DcUugGfY__"